import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingService } from './services/loading/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  /** ローディング表示状態 */
  public isLoading: Subject<boolean> = this.loadingService.isLoading;

  /**
   * コンストラクタ
   * @param {LoadingService} loadingService
   * @memberof LoadingComponent
   */
  constructor(private loadingService: LoadingService) { }

}

